module.exports = __webpack_public_path__ + "static/img/pineapple.d72f429.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/pineapple.jpg
// module id = i6Ph
// module chunks = 1